import ReactDOM from 'react-dom';
import { logger } from 'services';
const REACT_DOM_PKG = 'react-dom';
const getInternals = (mod)=>{
    if (!mod || typeof mod !== 'object') return undefined;
    const direct = mod.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    if (direct) return direct;
    const viaDefault = mod.default;
    return viaDefault === null || viaDefault === void 0 ? void 0 : viaDefault.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
};
const collectReactDomEntries = (source, scopes)=>{
    const out = [];
    for (const [scopeName, packages] of Object.entries(scopes !== null && scopes !== void 0 ? scopes : {})){
        const versions = packages === null || packages === void 0 ? void 0 : packages[REACT_DOM_PKG];
        if (!versions) continue;
        for (const [versionKey, entry] of Object.entries(versions)){
            out.push({
                source,
                scope: scopeName,
                version: versionKey,
                from: entry === null || entry === void 0 ? void 0 : entry.from,
                loaded: Boolean((entry === null || entry === void 0 ? void 0 : entry.loaded) || (entry === null || entry === void 0 ? void 0 : entry.loading)),
                hasLib: (entry === null || entry === void 0 ? void 0 : entry.lib) != null
            });
        }
    }
    return out;
};
/** Pure analyzer — separated from global access for unit-testability. */ export const analyzeMfSingletons = (globals, hostReactDomInternals)=>{
    var _ref;
    var _globals___FEDERATION__;
    const snapshot = [];
    for (const [shareName, scopes] of Object.entries((_ref = (_globals___FEDERATION__ = globals.__FEDERATION__) === null || _globals___FEDERATION__ === void 0 ? void 0 : _globals___FEDERATION__.__SHARE__) !== null && _ref !== void 0 ? _ref : {})){
        snapshot.push(...collectReactDomEntries(`federation:${shareName}`, scopes));
    }
    snapshot.push(...collectReactDomEntries('webpack-mf1', globals.__webpack_share_scopes__));
    const anomalies = [];
    // (1) A loaded entry whose module identity differs from the host copy.
    if (hostReactDomInternals) {
        var _ref1;
        var _globals___FEDERATION__1;
        const scopesToCheck = [
            ...Object.values((_ref1 = (_globals___FEDERATION__1 = globals.__FEDERATION__) === null || _globals___FEDERATION__1 === void 0 ? void 0 : _globals___FEDERATION__1.__SHARE__) !== null && _ref1 !== void 0 ? _ref1 : {}),
            globals.__webpack_share_scopes__
        ];
        for (const scopes of scopesToCheck){
            for (const packages of Object.values(scopes !== null && scopes !== void 0 ? scopes : {})){
                var _ref2;
                for (const entry of Object.values((_ref2 = packages === null || packages === void 0 ? void 0 : packages[REACT_DOM_PKG]) !== null && _ref2 !== void 0 ? _ref2 : {})){
                    const entryInternals = getInternals(entry === null || entry === void 0 ? void 0 : entry.lib);
                    if (entryInternals && entryInternals !== hostReactDomInternals) {
                        anomalies.push('foreign-live-react-dom');
                    }
                }
            }
        }
    }
    // (2) Devtools hook (extension users only — best effort).
    const hook = globals.__REACT_DEVTOOLS_GLOBAL_HOOK__;
    const hookPresent = Boolean(hook === null || hook === void 0 ? void 0 : hook.renderers);
    let rendererCount;
    if (hook === null || hook === void 0 ? void 0 : hook.renderers) {
        rendererCount = [
            ...hook.renderers.values()
        ].filter((r)=>{
            var _ref;
            return ((_ref = r === null || r === void 0 ? void 0 : r.rendererPackageName) !== null && _ref !== void 0 ? _ref : REACT_DOM_PKG) === REACT_DOM_PKG;
        }).length;
        if (rendererCount > 1) {
            anomalies.push('multiple-react-dom-renderers');
        }
    }
    // (3) More than one version key registered in a single scope.
    const versionsBySourceScope = new Map();
    for (const e of snapshot){
        var _versionsBySourceScope_get;
        const key = `${e.source}/${e.scope}`;
        const set = (_versionsBySourceScope_get = versionsBySourceScope.get(key)) !== null && _versionsBySourceScope_get !== void 0 ? _versionsBySourceScope_get : new Set();
        set.add(e.version);
        versionsBySourceScope.set(key, set);
    }
    for (const versions of versionsBySourceScope.values()){
        if (versions.size > 1) {
            anomalies.push('multiple-react-dom-versions');
            break;
        }
    }
    return {
        anomalies: [
            ...new Set(anomalies)
        ],
        snapshot,
        rendererCount,
        hookPresent
    };
};
const runCheck = (label)=>{
    try {
        const report = analyzeMfSingletons(globalThis, getInternals(ReactDOM));
        if (report.anomalies.length > 0) {
            logger.error(`mf-singleton-violation: ${report.anomalies.join(',')}`, {
                error: new Error(`mf-singleton-violation at ${label}`),
                report
            });
        }
    } catch (unused) {
    // Telemetry must never affect the app.
    }
};
/**
 * Check shortly after boot and again after the lazy routes / remotes have had
 * a chance to load — the dual-copy state can develop when a remote or a late
 * chunk resolves its shared singletons.
 */ export const scheduleMfSingletonChecks = ()=>{
    setTimeout(()=>runCheck('boot+5s'), 5000);
    setTimeout(()=>runCheck('boot+30s'), 30000);
};
